document.addEventListener('DOMContentLoaded', function () {
  initSizeChartButton();
});

function initSizeChartButton() {
  const tags = (window.productTagsForSizeChart || []).map(t => t.toLowerCase());
  const chartMap = window.sizeChartPages || {};

  const priority = ['oval-bracelet', 'bangle', 'rings', 'bracelet'];
  let matchedTag = priority.find(tag => tags.includes(tag));

  if (!matchedTag) return;

  const chartInfo = chartMap[matchedTag];
  if (!chartInfo) return;

  const legends = document.querySelectorAll('variant-selects legend, variant-selects label.form__label');
  let sizeLegend = null;

  legends.forEach(function (legend) {
    const nameSpan = legend.querySelector('.font-body-bold');
    if (!nameSpan) return;
    const optionName = nameSpan.textContent.trim().toLowerCase().replace(':', '');
    if (/\bsize\b/.test(optionName)) {
      sizeLegend = legend;
    }
  });

  if (!sizeLegend) return;
  if (sizeLegend.querySelector('.open-size-chart')) return;

  const button = document.createElement('a');
  button.href = chartInfo.url;
  button.target = '_blank';
  button.rel = 'noopener noreferrer';
  button.className = 'open-size-chart no-js-hidden btn--link tracking-normal';
  button.textContent = 'Size guide';
  button.style.marginLeft = '8px';
  sizeLegend.appendChild(button);
}